import { render, staticRenderFns } from "./importDataPage.vue?vue&type=template&id=3142205c&scoped=true"
import script from "./importDataPage.vue?vue&type=script&lang=js"
export * from "./importDataPage.vue?vue&type=script&lang=js"
import style0 from "./importDataPage.vue?vue&type=style&index=0&id=3142205c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142205c",
  null
  
)

export default component.exports